import * as React from 'react'
import { styled } from '@mui/material/styles'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import DoneIcon from '@mui/icons-material/Done'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
}))

const categoriesImport = [
    { key: 'files', label: 'File Import' },
    { key: 'text', label: 'Plain Text' },
    { key: 'google', label: 'Google' },
    { key: 'twitter', label: 'Twitter' },
    { key: 'youtube', label: 'YouTube' },
    { key: 'ai', label: 'AI & GPT LLMs' },
    { key: 'pkm', label: 'PKM & Knowledge Graphs' },
    { key: 'science', label: 'Scientific Databases' },
    { key: 'rss', label: 'RSS Feeds' },
    { key: 'urls', label: 'URLs' },
    { key: 'amazon', label: 'Amazon' },
    { key: 'note-tools', label: 'Note-Taking Tools' },
    { key: 'import', label: 'All Import Sources' },
]

export default function FilterChips({ onClick, selectedCategory }) {
    const [selectedChip, setSelectedChip] = React.useState(selectedCategory || 'files')

    React.useEffect(() => {
        if (selectedCategory != null && selectedCategory !== selectedChip) {
            setSelectedChip(selectedCategory)
        }
    }, [selectedCategory])

    const isMobile = useMediaQuery('(max-width:600px)')

    return (
        <Box
            component="ul"
            sx={{
                display: 'flex',
                listStyle: 'none',
                px: 0,
                pt: 0,
                flexWrap: 'wrap',
            }}
        >
            <Box
                sx={{
                    pt: 2,
                    pb: 1,
                }}
            >
                <Typography
                    component="h6"
                    variant="h6"
                    align="left"
                    color="text.primary"
                    sx={{
                        pl: 0.5,
                    }}
                >
                    {' '}
                </Typography>
            </Box>
            <Box
                sx={{
                    backgroundColor: theme => theme.palette.background.default,
                    display: 'flex',
                    listStyle: 'none',
                    px: 0,
                    flexWrap: 'wrap',
                    ml: 0,
                    pt: 0,
                }}
            >
                {categoriesImport.map(category => {
                    const onChipClick =
                        selectedChip === category.key
                            ? null
                            : () => {
                                  onClick(category.key)
                                  setSelectedChip(category.key)
                              }

                    return (
                        <ListItem key={category.key}>
                            <Chip
                                label={category.label}
                                color={
                                    selectedChip === category.key
                                        ? 'primary'
                                        : 'default'
                                }
                                sx={{
                                    fontSize: isMobile ? '0.8rem' : '1rem',
                                    fontWeight: '600',
                                    height: isMobile
                                        ? theme => theme.spacing(3)
                                        : theme => theme.spacing(4.5),
                                    paddingLeft: isMobile
                                        ? theme => theme.spacing(0.5)
                                        : theme => theme.spacing(1.5),
                                    paddingRight: isMobile
                                        ? theme => theme.spacing(0.5)
                                        : theme => theme.spacing(1.5),
                                }}
                                onClick={onChipClick}
                            />
                        </ListItem>
                    )
                })}
            </Box>
        </Box>
    )
}
